import React from "react";
import "./OurStrength.css";
import Image1 from "../../assets/Rectangle 28.jpg.webp";
import Image2 from "../../assets/Rectangle 21.jpg.webp";
import Image3 from "../../assets/Rectangle 23.jpg.webp";

const OurStrength: React.FC = () => {
  return (
    <section className="our-strength-section">
      <div className="image-grid">
        <img loading="lazy" decoding="async" src={Image1} alt="Curtains with sunlight" className="grid-image" />
        <img loading="lazy" decoding="async" src={Image2} alt="Indoor plants" className="grid-image" />
        <img loading="lazy" decoding="async" src={Image3} alt="Wooden stools" className="grid-image" />
      </div>
      <div className="text-section">
        <h1 className="heading">Lighting the Way to Brighter Living</h1>
        <p className="description">
          Bixton stands for more than just light; we bring warmth, happiness,
          and reliability into every space.
        </p>
      </div>
    </section>
  );
};

export default OurStrength;
